// Account Payable Mutations

export const setAccountPayableList = (state, payload) => {
  state.accountPayableList = payload
}

export const setAccountPayableInfo = (state, payload) => {
  state.accountPayableInfo = payload
}

export const setAccountPayableBalanceDetails = (state, payload) => {
  state.accountPayableBalanceDetails = payload
}
